import AuthGuard from "./auth_guard";

export default [
    {
        path: '/finance/transactions',
        name: 'transactions',
        component: () => import('../views/Finance/Transaction/Transactions.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: true, to: {} },
            { name: 'msg.transactions', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/transactions/transfer',
        name: 'transfer',
        component: () => import('../views/Finance/Transaction/Transfer.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transactions', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transfer', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/transactions/transfer/:id/edit',
        name: 'edit_transfer',
        component: () => import('../views/Finance/Transaction/Transfer.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transactions', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transfer', customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/transactions/create',
        name: 'create_transaction',
        component: () => import('../views/Finance/Transaction/CreateEditTransaction.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transactions', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/transactions/:id/edit',
        name: 'edit_transaction',
        component: () => import('../views/Finance/Transaction/CreateEditTransaction.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.transactions', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/finance/accounts',
        name: 'accounts',
        component: () => import('../views/Finance/Account/Accounts.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: true, to: {} },
            { name: 'msg.accounts', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/accounts/create',
        name: 'create_account',
        component: () => import('../views/Finance/Account/CreateEditAccount.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.accounts', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/accounts/:id/edit',
        name: 'edit_account',
        component: () => import('../views/Finance/Account/CreateEditAccount.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.accounts', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/finance/groups',
        name: 'groups',
        component: () => import('../views/Finance/Group/Groups.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: true, to: {} },
            { name: 'msg.groups', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/groups/create',
        name: 'create_group',
        component: () => import('../views/Finance/Group/CreateEditGroup.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.groups', customName: null, disabled: false, to: {name: 'groups'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/finance/groups/:id/edit',
        name: 'edit_group',
        component: () => import('../views/Finance/Group/CreateEditGroup.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.groups', customName: null, disabled: false, to: {name: 'groups'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/finance/month-budget',
        name: 'month_budget',
        component: () => import('../views/Finance/MonthBudget/MonthBudget'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.monthBudget', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/finance/month-budget/create',
        name: 'create_month_budget',
        component: () => import('../views/Finance/MonthBudget/Form'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.monthBudget', customName: null, disabled: false, to: {name: 'month_budget'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} },
        ]
    },
    {
        path: '/finance/month-budget/:id/edit',
        name: 'edit_month_budget',
        component: () => import('../views/Finance/MonthBudget/Form'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.finance', customName: null, disabled: false, to: {name: 'transactions'} },
            { name: 'msg.monthBudget', customName: null, disabled: false, to: {name: 'month_budget'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} },
        ]
    },
]